import { render, staticRenderFns } from "./ArtistBoardSuggestion.vue?vue&type=template&id=71d7dc30&scoped=true&"
import script from "./ArtistBoardSuggestion.vue?vue&type=script&lang=js&"
export * from "./ArtistBoardSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ArtistBoardSuggestion.vue?vue&type=style&index=0&id=71d7dc30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7dc30",
  null
  
)

export default component.exports